<template>
    <div>
        <table
            class="table products-table"
            v-if="!loading"
        >
            <thead>
                <tr>
                    <th colspan="2">
                        Product
                    </th>
                    <th>Quantity</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(siteProduct, index) in siteProducts"
                    :key="index"
                >
                    <td>
                        <img
                            v-if="siteProduct.product_id && getProductImage(siteProduct.product_id)"
                            :src="getProductImage(siteProduct.product_id)"
                        >
                    </td>
                    <td>
                        <products-select
                            v-model="siteProduct.product_id"
                            @input="emitChange"
                        />
                        <error
                            :errors="errors"
                            :name="`products.${index}.product_id`"
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            v-model="siteProduct.quantity"
                            step="1"
                            min="1"
                            class="form-control"
                            placeholder="Quantity"
                            @change="emitChange"
                        >
                        <error
                            :errors="errors"
                            :name="`products.${index}.quantity`"
                        />
                    </td>
                    <td class="text-right">
                        <button
                            class="btn btn-sm btn-outline-danger"
                            type="button"
                            @click.prevent="removeProduct(index)"
                            :disabled="saving"
                        >
                            <i class="fa fa-times" />
                        </button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td
                        colspan="4"
                        class="text-right"
                    >
                        <button
                            class="btn btn-primary"
                            v-if="showSave"
                            @click.prevent="saveProducts"
                            :disabled="saving"
                        >
                            <span v-show="!saving">Save Products</span>
                            <span v-show="saving">Saving Products...</span>
                        </button>
                        <button
                            class="btn btn-outline-info"
                            @click.prevent="addProduct"
                            :disabled="saving"
                        >
                            <i class="fa fa-plus" /> Add Product
                        </button>
                    </td>
                </tr>
            </tfoot>
        </table>
        <p v-if="loading">
            Loading site products...
        </p>
    </div>
</template>

<script>
import ProductsService from '../services/ProductsService';
import SitesService from '../services/SitesService';
import UsesErrors from '../mixins/UsesErrors';
import UsesInfoMessage from '../mixins/UsesInfoMessage';
import ProductsSelect from './ProductsSelectComponent';

export default {
    components: {
        ProductsSelect,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
    ],
    props: {
        siteId: {
            type: [Number, String],
            required: true,
        },
        showSave: {
            type: Boolean,
            default: false,
        },
    },

    data () {
        return {
            siteProducts: [],
            products: [],
            saving: false,
            loadingSite: false,
            loadingProducts: false,
        };
    },

    computed: {
        loading() {
            return this.loadingProducts && this.loadingSite;
        },
    },

    watch: {
        siteId: {
            immediate: true,
            handler() {
                this.loadSiteProducts();
            },
        },
    },

    created() {
        this.loadProducts();
    },

    methods: {
        loadSiteProducts() {
            if (!this.siteId) {
                this.siteProducts = [];
                return;
            }
            this.loadingSite = true;
            SitesService.get(this.siteId).then(res => {
                this.siteProducts = res.data.products.map(p => {
                    if (!isNaN(p.product_id)) {
                        p.product_id = parseInt(p.product_id);
                    }

                    return p;
                });
                this.loadingSite = false;
            }).catch(err => {
                this.showErrorMessage('Error: Failed to load site products');
                this.loadingSite = false;
                throw err;
            });
        },

        loadProducts() {
            this.loadingProducts = true;
            ProductsService.index().then(res => {
                this.products = window._.sortBy(res.data, ['code', 'name']);
                this.loadingProducts = false;
            }).catch(err => {
                this.loadingProducts = false;
                this.showErrorMessage('Error: Failed to load products');
                throw err;
            });
        },

        removeProduct (index) {
            this.siteProducts.splice(index, 1);
            this.emitChange();
        },

        addProduct () {
            this.siteProducts.push({
                product_id: null,
                quantity: 1, 
            });
            this.emitChange();
        },

        emitChange() {
            this.$emit('change', this.siteProducts);
        },

        getProductImage(id) {
            if (!id) {
                return null;
            }

            const product = this.products.find(p => p.id === parseInt(id));
            if (!product) {
                return null;
            }

            return product.photo_url;
        },

        saveProducts() {
            let confirm = window.confirm('Are you sure you want to save the site products?');
            if (!confirm) {
                return;
            }
            this.clearErrors();
            this.saving = true;
            SitesService.updateProducts(this.siteId, this.siteProducts).then(res => {
                this.siteProducts = res.data.products;
                this.saving = false;
                this.emitChange(this.siteProducts);
                this.setInfoMessage('Site products saved successfully');
            }).catch(err => {
                this.saving = false;
                this.captureRequestErrors(err);
                this.showErrorMessage('Error saving site products, please check for errors and try again');
            });

        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SiteProductsComponent.vue